var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-gene-lab-order',{ref:"detail",staticClass:"pt-gene-lab-order__withData",attrs:{"exportLoading":_vm.exportLoading},on:{"getOrderExportExcel":_vm.getOrderExportExcel}})}
var staticRenderFns = []

export { render, staticRenderFns }